import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { FooterAction } from "@/components/organisms/FooterAction";
import { saveLeadData } from "@/redux/actions/vida";
import { planSelected as planSelectedAction } from "@/redux/actions/plans";
import { StateMachine } from "@/utils/consts";
import history from "@/utils/history";
import helpers from "@/utils/helpers";
import { formatAmountThousand } from "@/utils/Utils";
import { configVisaDecode } from "@/utils/awsConfig";
import { usePlanService } from "@/services/plan.service";
import { usePlansContext } from "../../context/PlansContext";
import { DetailPlanMobile } from "./DetailPlanMobile";
import { showModalLoading } from "@/redux/actions/global";
import { useLeadsService } from "@/services/leads.service";

export const SectionAction = ({ pathQuoteError, nextStep }) => {
  const [loading, setLoading] = useState(false);

  const leadData = useSelector((state) => state.vida.leadData);
  const state = useSelector((state) => state.global.state);
  const { planSelected, nameFrequency, typeOfFinancing } = useSelector(
    (state) => state.plans
  );
  const {
    sumAssured,
    savingTime,
    returnPercentage,
    frequency,
    ideTransaccion,
  } = planSelected || {};
  const { ideFinanciamiento, idePlanFinanciamiento, pagoMensual } =
    typeOfFinancing || {};

  const dispatch = useDispatch();
  const { selectQuote } = usePlanService();
  const { isLoadingData } = usePlansContext();
  const { sendLeads } = useLeadsService();

  const onHandleClick = async () => {
    const leadToSend = {
      ...leadData,
      atributos: {
        ...leadData.atributos,
        dscPlan: planSelected.plan.dscPlan,
        idPlan: planSelected.plan.idePlan,
      },
      finalizado: 2,
    };

    dispatch(showModalLoading("Continuemos con el segundo paso"));
    helpers.getTagVirtual("sol:comprar:seguro-vida-devolucion-garantizada:loader-direccion");
    setLoading(true);
    
    await dispatch(saveLeadData(leadToSend));
    await sendLeads(leadToSend);
    await selectedPlanToService();

    if (state !== StateMachine[4]) {
      const sumAssuredValue = sumAssured.text.replace(/[^\d]/g, "");
      helpers.getTagMetadata(
        "Cotización Seguro Vida Devolución Garantizada - B",
        `${sumAssuredValue} - ${savingTime?.text} años - ${returnPercentage?.text}`,
        "trackMetadata"
      );
      sendFrequencyTracking();
      dispatch(showModalLoading(""));
      history.push(nextStep);
    }
  };

  const selectedPlanToService = async () => {
    const request = {
      ideTransaccion,
      idePlan: planSelected.plan.idePlan,
      ideFinanciamiento: ideFinanciamiento,
      idePlanFinanciamiento: idePlanFinanciamiento,
      clienteAplicacion: configVisaDecode[1].value,
    };
    const response = await selectQuote(request);
    await dispatch(
      planSelectedAction({
        ...planSelected,
        idSolicitud: response?.payload?.idSolicitud,
        frequency,
      })
    );
    setLoading(false);
  };

  const sendFrequencyTracking = () => {
    helpers.getTagMetadata(
      "Frecuencia Seguro Vida Devolución Garantizada - B",
      `${helpers.capitalize(nameFrequency)} - ${formatAmountThousand(
        pagoMensual
      )}`,
      "trackMetadata"
    );
  };

  return (
    <FooterAction
      loading={loading}
      loadingAnimation={isLoadingData}
      disabled={isLoadingData}
      contentAdditional={<DetailPlanMobile />}
      onHandleClick={onHandleClick}
    />
  );
};
